import { endOfSkippable } from "./end-of-skippable";
import { endOfStringLiteral } from "./end-of-string-literal";
import { unescapeStringLiteral } from "./unescape-string-literal";

/** The quoted value of `field:` starting at `at`, JSON-style keys included. */
export function quotedFieldAt(
  literal: string,
  at: number,
  field: string,
): string | undefined {
  const key = /^(['"])?/.exec(literal.slice(at));
  const quoted = key?.[1] ?? "";
  const start = at + quoted.length;
  if (!literal.startsWith(field, start)) return undefined;
  if (!quoted && /[A-Za-z0-9_$]/.test(literal[at - 1] ?? "")) return undefined;
  const after = literal.slice(start + field.length);
  const opener = new RegExp(`^${quoted}\\s*:\\s*['"\`]`).exec(after);
  if (!opener) return undefined;
  const quote = start + field.length + opener[0].length - 1;
  const close = endOfStringLiteral(literal, quote);
  // A literal that only OPENS the value (`'a' + b`, a template with a hole) is
  // not the value: the authoritative parser evaluates it, this cannot.
  let tail = close + 1;
  for (;;) {
    while (/\s/.test(literal[tail] ?? "")) tail += 1;
    const skipped = endOfSkippable(literal, tail);
    if (skipped === tail) break;
    tail = skipped + 1;
  }
  if (literal[tail] !== "," && literal[tail] !== "}") return undefined;
  if (literal[quote] === "`" && /\$\{/.test(literal.slice(quote, close))) {
    return undefined;
  }
  // The VALUE, not its source text: the run row stores what JavaScript builds.
  return unescapeStringLiteral(literal.slice(quote + 1, close));
}
